module.exports = __webpack_public_path__ + "html/section-video-gallery_311c6de62f4d343d596817287272d2ee.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-gallery.html
// module id = lU18
// module chunks = 55